import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import { normalizeSalesPreview } from "./salesReconciliationModel";

export async function loadSalesSellers(headers, fromDate, toDate, signal) {
  const response = await axios.get(`${ApiLink.API_URL}SalesReconciliation/sellers`, {
    headers, signal, params: { fromDate, toDate },
  });
  if (!Array.isArray(response.data) || response.data.some((seller) => typeof seller !== "string"))
    throw new Error("Lista e shitësve nuk është valide.");
  return response.data;
}

export async function loadSalesPreview(headers, seller, fromDate, toDate, signal) {
  const response = await axios.get(`${ApiLink.API_URL}SalesReconciliation/preview`, {
    headers, signal, params: { Seller: seller, FromDate: fromDate, ToDate: toDate },
  });
  return normalizeSalesPreview(response.data, seller);
}

export async function loadTransferOptions(headers, seller, fromDate, toDate, signal) {
  const response = await axios.get(`${ApiLink.API_URL}SalesReconciliationTransfer/options`, {
    headers, signal, params: { seller, fromDate, toDate },
  });
  if (!response.data?.Source?.AccountID || !Array.isArray(response.data.Destinations))
    throw new Error("Nuk u gjet arka e shitësit.");
  return response.data;
}

export async function saveReconciliationTransfer(headers, request) {
  const response = await axios.post(`${ApiLink.API_URL}SalesReconciliationTransfer`, request, { headers });
  return response.data;
}

export async function loadReconciliationCompany(headers, signal) {
  const response = await axios.get(`${ApiLink.API_URL}Companies/getCompanyDetails`, { headers, signal });
  const company = Array.isArray(response.data) ? response.data[0] : null;
  if (!company?.CompanyName) throw new Error("Nuk u ngarkuan të dhënat e kompanisë për printim.");
  return company;
}
